import useSWR from "swr";
import { getReplacementCharacters } from "../services/template-service";
import type {
  ReplacementCharactersResponse,
  ReplacementCharacterItem,
} from "../types/api-types";

export interface UseReplacementCharactersReturn {
  replacementCharacters: ReplacementCharacterItem[] | undefined;
  isLoading: boolean;
  // SWR returns any, so a more explicit type cannot be used
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  mutate: () => void;
}

const useReplacementCharacters = (
  templateId: number | null,
): UseReplacementCharactersReturn => {
  const { data, error, isLoading, mutate } =
    useSWR<ReplacementCharactersResponse>(
      templateId ? `replacement-characters-${templateId}` : null,
      () =>
        templateId
          ? getReplacementCharacters(templateId)
          : Promise.resolve({ results: [] }),
    );

  return {
    replacementCharacters: data?.results,
    isLoading,
    error,
    mutate,
  };
};

export default useReplacementCharacters;
